import { formatDate } from "~/lib/helpers/dateFormatHelper"
import { cn } from "~/lib/utils"

const Content = ({ date, className }) => {
  return (
    <p className={cn("text-gray-600 text-sm mt-2 py-3", className)}>
      This property’s price was verified on{" "}
      <strong>{formatDate(date, 'D MMMM YYYY')}</strong>.
    </p>
  )
}

export default Content